"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfBusiness = void 0;
var LineOfBusiness;
(function (LineOfBusiness) {
    LineOfBusiness["Industry"] = "INDUSTRY";
    LineOfBusiness["Commerce"] = "COMMERCE";
    LineOfBusiness["Services"] = "SERVICES";
})(LineOfBusiness || (exports.LineOfBusiness = LineOfBusiness = {}));
//# sourceMappingURL=storefront.js.map